import { create } from 'zustand';

/**
 * Short-lived messages for actions that fail away from any form: a PDF
 * download, a note saved from a list, a toggle. Before this the handlers
 * caught the error, logged it to the console and did nothing, so a click
 * that failed looked like a click that did nothing.
 *
 * `notifyError(message, error)` is the call sites' whole interface: it
 * keeps the console line (the detail a developer needs) and shows the
 * person a sentence. Rendered by components/common/Toaster.jsx.
 */
let nextId = 1;
const LIFETIME_MS = 6000;

export const useToastStore = create((set, get) => ({
  toasts: [],
  push: (toast) => {
    const id = nextId++;
    set({ toasts: [...get().toasts, { id, kind: 'error', ...toast }].slice(-4) });
    setTimeout(() => get().dismiss(id), LIFETIME_MS);
    return id;
  },
  dismiss: (id) => set({ toasts: get().toasts.filter((t) => t.id !== id) }),
}));

/** Tell the person an action failed; the server's own message wins when it sent one. */
export function notifyError(message, error) {
  if (error) console.error(message, error);
  const server = error?.response?.data?.error;
  useToastStore.getState().push({ kind: 'error', message: typeof server === 'string' && server ? `${message} ${server}` : message });
}
